import styled from '@emotion/styled/macro';

export const TooltipWrapper = styled.span`
    display: inline-block;
`;
